import React, { useState, useEffect } from "react";
import { useStateValue } from "../context/StateProvider";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import WhiteLogo from "../images/whitelogo.png";
import userlogo from "../images/user.png";
import Signins from "../images/signin.png";
import { MdWorkHistory } from "react-icons/md";
import { MdPeopleAlt } from "react-icons/md";
import { MdCalendarMonth } from "react-icons/md";
import { AiOutlineProject } from "react-icons/ai";
import { FaShuttleVan } from "react-icons/fa";
import { MdAssignmentAdd } from "react-icons/md";
import { MdSupportAgent } from "react-icons/md";
import { FaBloggerB } from "react-icons/fa";
import { TbLogout2 } from "react-icons/tb";
import { MdDashboard } from "react-icons/md";
import { MdWorkspaces } from "react-icons/md";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { actionType } from "../context/reducer";
import { getToken } from "firebase/messaging";
import { messaging } from "./../../firebase.config";
import "./index.css";
import { updateItem } from "../../utils/firebasefunctions";

const SideMenu = (props) => {
  const [{ user, employees, clients, projects, selectedtile }, dispatch] =
    useStateValue();
  const auth = getAuth();
  const navigate = useNavigate();

  // State to handle collapsing for medium screens and up
  const [isCollapsed, setIsCollapsed] = useState(false);

  const listing = [
    {
      label: "Dashboard",
      image: <MdDashboard size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin", "Supervisor"],
    },
    {
      label: "Slots",
      image: <MdWorkspaces size={20} />,
      allowedusertypes: ["Supervisor"],
    },
    {
      label: "Express Delivery",
      image: <MdWorkspaces size={20} />,
      allowedusertypes: ["Supervisor"],
    },
    {
      label: "Employees",
      image: <MdWorkHistory size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin", "Supervisor"],
    },
    {
      label: "Create User",
      image: <MdPeopleAlt size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Leave Request",
      image: <MdCalendarMonth size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Vehicle",
      image: <FaShuttleVan size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin", "Supervisor"],
    },
    {
      label: "To Do List",
      image: <MdAssignmentAdd size={20} />,
      allowedusertypes: ["Supervisor"],
    },
    {
      label: "Create Project",
      image: <AiOutlineProject size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Assign Project",
      image: <MdAssignmentAdd size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Assign Vehicle",
      image: <MdAssignmentAdd size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Support",
      image: <MdSupportAgent size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin"],
    },
    {
      label: "Blogs",
      image: <FaBloggerB size={20} />,
      allowedusertypes: ["SuperAdmin", "Admin", "Supervisor"],
    },
  ];

  const editprofile = () => {
    navigate("/dashboard", {
      state: {
        employeedata: user,
      },
    });
  };

  function tileselection(data) {
    dispatch({
      type: actionType.STORE_SELECTED_TILE,
      payload: data,
    });
  }

  const signout = async () => {
    signOut(auth)
      .then(() => {
        dispatch({
          type: actionType.SET_USER,
          payload: [],
        });
        navigate("/");
      })
      .catch((error) => {
        alert("sign out error");
      });
  };

  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BBb7l_frsXySelNGhOBb5H1qNI7jOb5qdqpivVz2CPiw3sc9nfg6EW4Ub6oSUPOCbH52Q6TOejfZTExlxHovnCc",
      });

      if (
        user?.NotificationToken != undefined &&
        user?.NotificationToken?.find((item) => item == token) != undefined
      ) {
        let data = [...user.NotificationToken];
        data = data.filter(function (item) {
          return item != token;
        });

        let dataset = {
          NotificationToken: data,
        };

        await updateItem("users", user?.id, dataset)
          .then(async (response) => {
            signout();
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        signout();
      }
    } else if (permission === "denied") {
      signout();
    }
  }

  return (
    <div
      className={`relative bg-themelightblack bg-cardOverlay  rounded-tr-2xl rounded-br-2xl  drop-shadow-lg  h-screen transition-all duration-300 flex flex-col px-3 md:px-4  hidden  md:flex   ${isCollapsed ? "md:w-[80px]" : "md:w-[260px]"}
      `}
    >
      {/* Collapse Toggle Button for Medium Screens and up */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="hidden md:flex absolute -right-3 top-7 bg-themeblue text-white w-6 h-6 rounded-full items-center justify-center shadow-md z-20 hover:opacity-90 transition-opacity"
        title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        {isCollapsed ? (
          <FiChevronRight size={14} />
        ) : (
          <FiChevronLeft size={14} />
        )}
      </button>

      {/* Top Header / Profile Section */}
      <div className="h-[28%] overflow-hidden flex flex-col justify-center border-b border-white/10">
        <div
          className={`w-full flex items-center py-4 ${
            isCollapsed ? "justify-center" : "justify-between"
          }`}
        >
          <img
            loading="lazy"
            src={WhiteLogo}
            className={`${
              isCollapsed ? "w-[35px]" : "w-[50%]"
            } object-contain transition-all duration-300`}
          />
        </div>

        <div
          className={`flex items-center py-3 transition-all duration-300 ${
            isCollapsed ? "justify-center" : "flex-row"
          }`}
        >
          <img
            loading="lazy"
            src={
              user?.profilepicture
                ? user?.profilepicture
                : user?.logo
                  ? user?.logo
                  : userlogo
            }
            className="w-[45px] h-[45px] md:w-[50px] md:h-[50px] object-cover rounded-full border border-white/20 shadow-sm flex-shrink-0"
          />
          {!isCollapsed && (
            <div className="flex flex-col ml-3 min-w-0">
              <p className="text-white PoppinsRegular text-sm font-medium truncate">
                {user?.usertype == "Project"
                  ? user?.name
                  : user?.usertype == "Project"
                    ? user?.title
                    : user?.firstname + " " + user?.lastname}
              </p>
              <p className="text-lightgrey PoppinsRegular text-[11px] truncate">
                {user?.clientrole ? "Client" : user?.usertype}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Navigation Listing Section */}
      <div className="flex flex-col justify-between h-[72%] overflow-hidden py-3">
        <div className="max-h-[100%] overflow-y-auto space-y-1.5 pr-1 custom-scrollbar">
          {listing &&
            listing.map(
              (item, index) =>
                item.allowedusertypes.includes(user.usertype) && (
                  <React.Fragment key={index.toString()}>
                    {(item.label == "To Do List" && user?.clientrole == true) ||
                    (item.label == "Vehicle" && user?.clientrole == true) ||
                    (item.label == "Express Delivery" &&
                      user?.clientrole != true) ? null : (
                      <div
                        onClick={() => {
                          if (item.label == "Support") {
                            navigate("/Messages");
                          } else if (item.label == "Employees") {
                            navigate("/employees");
                          } else {
                            tileselection(item.label);
                          }
                        }}
                        title={isCollapsed ? item.label : ""}
                        className={`${
                          selectedtile == item.label
                            ? `text-white bg-themeblue shadow-sm rounded-md`
                            : "text-white/80 hover:text-white hover:bg-white/5"
                        } relative rounded-md px-2.5 cursor-pointer h-[44px] flex items-center ${
                          isCollapsed ? "justify-center" : "justify-start"
                        } transition-colors duration-150 text-[14px]`}
                      >
                        <div className="flex-shrink-0 flex items-center justify-center">
                          {item.image}
                        </div>

                        {!isCollapsed && (
                          <p className="whitespace-nowrap PoppinsRegular ml-3 truncate flex-1">
                            {item.label}
                          </p>
                        )}

                        {!isCollapsed &&
                        ((user?.newmessage == true &&
                          item.label == "Support") ||
                          (user?.newleaverequest == true &&
                            item.label == "Leave Request") ||
                          (user?.newblogpost == true &&
                            item.label == "Blogs")) ? (
                          <div className="bg-red-600 flex items-center justify-center rounded px-1.5 py-0.5 ml-auto">
                            <span className="PoppinsRegular text-white text-[9px] font-semibold tracking-wider">
                              NEW
                            </span>
                          </div>
                        ) : null}

                        {/* Notification Dot indicator for collapsed view */}
                        {isCollapsed &&
                        ((user?.newmessage == true &&
                          item.label == "Support") ||
                          (user?.newleaverequest == true &&
                            item.label == "Leave Request") ||
                          (user?.newblogpost == true &&
                            item.label == "Blogs")) ? (
                          <span className="absolute top-2 right-2 w-2 h-2 bg-red-600 rounded-full"></span>
                        ) : null}
                      </div>
                    )}
                  </React.Fragment>
                ),
            )}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
